export type PasswordRule = {
  id: string;
  label: string;
  test: (value: string) => boolean;
};

export const PASSWORD_RULES: PasswordRule[] = [
  { id: 'min', label: 'At least 8 characters', test: (v) => v.length >= 8 },
  { id: 'max', label: 'No more than 64 characters', test: (v) => v.length > 0 && v.length <= 64 },
  { id: 'upper', label: 'At least one uppercase letter', test: (v) => /[A-Z]/.test(v) },
  { id: 'lower', label: 'At least one lowercase letter', test: (v) => /[a-z]/.test(v) },
  { id: 'digit', label: 'At least one number', test: (v) => /[0-9]/.test(v) },
  { id: 'special', label: 'At least one special character', test: (v) => /[^A-Za-z0-9]/.test(v) },
];

export type PasswordRuleResult = { id: string; label: string; met: boolean };

export function evaluatePasswordRules(value: string): PasswordRuleResult[] {
  return PASSWORD_RULES.map((rule) => ({ id: rule.id, label: rule.label, met: rule.test(value) }));
}

export function isPasswordValid(value: string): boolean {
  return PASSWORD_RULES.every((rule) => rule.test(value));
}
